import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#034ea2",
      contrastText: "#fff",
    },
    secondary: {
      main: "#fb8b0e",
      contrastText: "#fff",
    },
  },
  typography: {
    fontFamily: "Poppins, Arial, sans-serif",
    h1: {
      color: "#000",
    },
    body1: {
      color: "#737373",
    },
    body2: {
      color: "#737373",
      fontSize: "13px",
    },
  },
});

export default theme;
